import {Form as AntForm} from 'antd';
import React, {useEffect} from 'react';

import Form from '../../../../components/Form/Form';
import MobileModalForm from '../../../../components/Form/MobileModalForm';
import * as fieldNames from '../../../../consts/form/formInputNames';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import log from '../../../../services/logger/log';
import helpers from '../../../../utils/helpers';
import gatewayModalService from './gatewayModalService';

const GatewayModal = ({modalType, onCancel, onOk}) => {
    const [form] = AntForm.useForm();
    const isMobile = useIsMobileViewport();
    const localizedStrings = getLocalizedStrings();

    const {formFields, title, submitButton, cancelButton, initialValues} = gatewayModalService.getFormContent(
        modalType,
        form
    );

    useEffect(() => {
        document.body.classList.add('gateway-modal-open');

        return () => document.body.classList.remove('gateway-modal-open');
    }, []);

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }

        return () => {
            form.resetFields();
        };
    }, []);

    const onFinish = async () => {
        try {
            const values = await form.validateFields();

            helpers.runFunction(onOk, values);
        } catch (error) {
            log.info('Validate Failed:', error);
        }
    };

    if (isMobile) {
        return (
            <MobileModalForm
                form={form}
                formName={`gateway-mobile-${modalType}`}
                title={title}
                closeLabel={localizedStrings[localizationKeys.GATEWAYS_MOBILE_CLOSE_FORM]}
                formFields={formFields.map((field) => ({
                    ...field,
                    ...(field.name === fieldNames.ID && {
                        autoComplete: 'off',
                        autoCapitalize: 'none',
                        spellCheck: false,
                    }),
                    ...([fieldNames.LATITUDE, fieldNames.LONGITUDE].includes(field.name) && {inputMode: 'decimal'}),
                    ...(field.name === fieldNames.STATS_INTERVAL && {inputMode: 'numeric'}),
                }))}
                initialValues={initialValues}
                onFinish={onFinish}
                onCancel={onCancel}
                submitButton={submitButton}
                cancelButton={cancelButton}
            />
        );
    }

    return (
        <Form
            closeModal={onCancel}
            initialValues={initialValues}
            submitButton={submitButton}
            onFinish={onFinish}
            title={title}
            formFields={formFields}
            cancelButton={cancelButton}
            formInstance={form}
            formClassName='gateway-form'
            containerClassName='gateway-form-content'
            buttonsClassName='gateway-form-actions'
        />
    );
};

export default React.memo(GatewayModal);
